import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditAgent from "../../components/agents/FormAddEditAgent";
import { useNavigate } from "react-router-dom";

const CreateAgent = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAgent
                isEdit={false}
                onSubmitSuccess={() => navigate("/agents")}
            />
        </WrapperSection>
    );
};

export default CreateAgent;
